import { render, staticRenderFns } from "./verify-group-payment.vue?vue&type=template&id=5370316c"
import script from "./verify-group-payment.vue?vue&type=script&lang=js"
export * from "./verify-group-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports